export default {"src":"/_next/static/media/chevron-right.9aadceed.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};